<template>
  <LazyContainer padding-top>
    <h1>{{ blok.title }}</h1>
    <LazySbText :blok="blok" />
    <LazyGallery :items="blok.items" />
  </LazyContainer>
  <!-- <StoryblokComponent v-for="blokBody in blok.blocks" :key="blokBody._uid" :blok="blokBody" /> -->
</template>
<script setup>
const { formatAlbum, formatBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })

formatAlbum({ title: props.blok.title, description: props.blok.descritpion, items: props.blok.items })
formatBreadcrumbs()
</script>
